module.exports = __webpack_public_path__ + "img/tango_story.b413d914.jpg";